export const getIntrinsicLottieDimensions = (animationData: any): { width: number; height: number } | null => {
  if (!animationData || typeof animationData !== 'object') {
    return null;
  }

  // Lottie animation data has 'w' (width) and 'h' (height) properties
  const { w: width, h: height } = animationData;

  if (typeof width !== 'number' || typeof height !== 'number' || width <= 0 || height <= 0) {
    return null;
  }

  return { width, height };
};

export const calculateLottieBounds = (containerElement: HTMLElement | null, animationData: any) => {
  if (!containerElement || !animationData) {
    return null;
  }

  const containerRect = containerElement.getBoundingClientRect();
  const parentRect = containerElement.parentElement?.getBoundingClientRect();

  if (!containerRect.width || !containerRect.height || !parentRect) {
    return null;
  }

  const intrinsicDimensions = getIntrinsicLottieDimensions(animationData);
  if (!intrinsicDimensions) {
    return null;
  }

  const { width: naturalWidth, height: naturalHeight } = intrinsicDimensions;
  const lottieAspectRatio = naturalWidth / naturalHeight;
  const containerAspectRatio = containerRect.width / containerRect.height;

  let actualLottieWidth: number;
  let actualLottieHeight: number;
  let offsetX: number;
  let offsetY: number;

  if (lottieAspectRatio > containerAspectRatio) {
    // Lottie is wider than container, fit to width
    actualLottieWidth = containerRect.width;
    actualLottieHeight = containerRect.width / lottieAspectRatio;
    offsetX = 0;
    offsetY = (containerRect.height - actualLottieHeight) / 2;
  } else {
    // Lottie is taller than container, fit to height
    actualLottieHeight = containerRect.height;
    actualLottieWidth = containerRect.height * lottieAspectRatio;
    offsetX = (containerRect.width - actualLottieWidth) / 2;
    offsetY = 0;
  }

  // Calculate positions relative to parent
  const containerLeft = containerRect.left - parentRect.left;
  const containerTop = containerRect.top - parentRect.top;
  const lottieLeft = containerLeft + offsetX;
  const lottieTop = containerTop + offsetY;

  // Convert to percentage
  return {
    left: (lottieLeft / parentRect.width) * 100,
    top: (lottieTop / parentRect.height) * 100,
    width: (actualLottieWidth / parentRect.width) * 100,
    height: (actualLottieHeight / parentRect.height) * 100
  };
};
